import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Chart from 'react-apexcharts';
import Actions_Wind from '~/Actions_Wind';
import SearchBar from '~/components/SearchBar';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import chartOptions from './chartOptions';
import './chart.css';

const App = props => {
  const {} = props;
  const [windId, setWindId] = useState('');
  const dispatch = useDispatch();
  const SwitchProjectList = useSelector(state => state.data.SwitchProjectList || []);
  const WindsForeignBoatList = useSelector(state => state.data.WindsForeignBoatList || []);
  const onClickSearch = () => Actions_Wind.Gis.getWindsForeignBoatList(dispatch, { id: windId });
  const haveData = WindsForeignBoatList.length > 0;
  const chartData = WindsForeignBoatList.map((o, i) => (
    {
      x: `(#${i + 1})${o.exec_job}（${o.ship_name}）`,
      y: [
        new Date(o.start_date).getTime(),
        new Date(o.end_date).getTime(),
      ],
    }
  ));
  useEffect(() => () => Actions_Wind.clearKey(dispatch, { key: 'WindsForeignBoatList' }), []);
  return (
    <SearchBar style={{ marginTop: 16 }} text='外籍船期資訊'>
      <div style={{ display: 'flex' }}>
        <div>
          <S_Title text='風場' />
          <S_Select list={SwitchProjectList} value={windId} onChange={t => setWindId(t)} />
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={onClickSearch} />
        </div>
      </div>

      {haveData && (
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)', backgroundColor: 'white' }}>
            <Chart
              style={{ marginRight: 12 }}
              options={chartOptions({ data: WindsForeignBoatList })}
              series={[{
                data: chartData,
              }]}
              type="rangeBar"
              // width="500"
              height={(chartData.length * 20 + 70).toString()}
            />
          </div>
        </div>
      )}

      {!haveData && <div style={{ margin: 20, fontSize: 20, textAlign: 'center' }}>(暫無資料)</div>}

    </SearchBar>
  );
};

export default App;
